import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from './context/AuthContext';
import { TutorialProvider } from './context/TutorialContext';
import ScrollToTop    from './components/ScrollToTop';
import Navbar         from './components/Navbar';
import Footer         from './components/Footer';
import ErrorBoundary  from './components/ErrorBoundary';
import LandingPage     from './pages/LandingPage';
import AboutPage       from './pages/AboutPage';
import Dashboard       from './pages/Dashboard';
import MarketPage      from './pages/MarketPage';
import PrivacyPolicy   from './pages/PrivacyPolicy';
import TermsOfUse      from './pages/TermsOfUse';
import BlogHub         from './pages/BlogHub';
import Academy         from './pages/Academy';
import News            from './pages/News';
import BlogPost        from './pages/BlogPost';
import ComingSoon      from './pages/ComingSoon';
import ResetPassword   from './pages/ResetPassword';
import EmailConfirmed  from './pages/EmailConfirmed';
import ProfilePage     from './pages/ProfilePage';

// ============================================================
// MAINTENANCE MODE
// true  = everyone sees the Coming Soon page
// false = full site is live
// ============================================================
const MAINTENANCE_MODE = true;

function App() {
  if (MAINTENANCE_MODE) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<ComingSoon />} />
        </Routes>
      </Router>
    );
  }

  return (
    <ErrorBoundary fullPage>
      <AuthProvider>
        <TutorialProvider>
          <Router>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/"                element={<LandingPage />} />
              <Route path="/about"           element={<AboutPage />} />
              <Route path="/dashboard"       element={<ErrorBoundary><Dashboard /></ErrorBoundary>} />
              <Route path="/market/:id"      element={<ErrorBoundary><MarketPage /></ErrorBoundary>} />
              <Route path="/privacy"         element={<PrivacyPolicy />} />
              <Route path="/terms"           element={<TermsOfUse />} />
              <Route path="/blog"            element={<BlogHub />} />
              <Route path="/academy"         element={<Academy />} />
              <Route path="/news"            element={<News />} />
              <Route path="/blog/:slug"      element={<BlogPost />} />
              <Route path="/reset-password"  element={<ResetPassword />} />
              <Route path="/confirmed"       element={<EmailConfirmed />} />
              <Route path="/profile"         element={<ErrorBoundary><ProfilePage /></ErrorBoundary>} />
            </Routes>
            <Footer />
          </Router>
          <Analytics />
        </TutorialProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
